/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_EmailInputs */

const en_roster_email = /** @type {(inputs: Roster_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const es_roster_email = /** @type {(inputs: Roster_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo`)
};

const fr_roster_email = /** @type {(inputs: Roster_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const de_roster_email = /** @type {(inputs: Roster_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const id_roster_email = /** @type {(inputs: Roster_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/** @type {(inputs: Roster_EmailInputs) => LocalizedString} */
const ja_roster_email = en_roster_email;

/** @type {(inputs: Roster_EmailInputs) => LocalizedString} */
const zh_roster_email = en_roster_email;

/** @type {(inputs: Roster_EmailInputs) => LocalizedString} */
const ar_roster_email = en_roster_email;

/** @type {(inputs: Roster_EmailInputs) => LocalizedString} */
const it_roster_email = en_roster_email;

/** @type {(inputs: Roster_EmailInputs) => LocalizedString} */
const ru_roster_email = en_roster_email;

/** @type {(inputs: Roster_EmailInputs) => LocalizedString} */
const pt_roster_email = en_roster_email;

/** @type {(inputs: Roster_EmailInputs) => LocalizedString} */
const ko_roster_email = en_roster_email;

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Roster_EmailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_email = /** @type {((inputs?: Roster_EmailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_EmailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_email(inputs)
	if (locale === "es") return es_roster_email(inputs)
	if (locale === "fr") return fr_roster_email(inputs)
	if (locale === "de") return de_roster_email(inputs)
	if (locale === "ja") return ja_roster_email(inputs)
	if (locale === "zh") return zh_roster_email(inputs)
	if (locale === "ar") return ar_roster_email(inputs)
	if (locale === "id") return id_roster_email(inputs)
	if (locale === "it") return it_roster_email(inputs)
	if (locale === "ru") return ru_roster_email(inputs)
	if (locale === "pt") return pt_roster_email(inputs)
	return ko_roster_email(inputs)
});